import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function UpdateProfile() {
    const navigate = useNavigate();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const userid = localStorage.getItem("userId");
    const [loading, setLoading] = useState(true);
    const [profilePic, setProfilePic] = useState(null); // Store profile photo URL or preview
    const [selectedFile, setSelectedFile] = useState(null); // Store selected file for upload
    const [userDetails, setUserDetails] = useState({
        userid: null,
        fname: "",
        lname: "",
        dob: "",
        gender: "",
        address: "",
        weight: "",
        height: "",
        eyecolor: "",
        haircolor: "",
        children_ages: "",
        occupation: "",
        hobbies: "",
        personality: "",
        person_to_marry: "",
        yourself_in_future: "",
    });

    // Fetch user data including profile picture
    const fetchSingleUserData = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/users/getfiltereduser`, {
                id: userid,
            });
            const user = response.data.data[0];
            setUserDetails({
                fname: user.fname || "",
                lname: user.lname || "",
                dob: user.dob || "",
                address: user.address || "",
                gender: user.gender || "",
                weight: user.weight || "",
                height: user.height || "",
                eyecolor: user.eyecolor || "",
                haircolor: user.haircolor || "",
                children_ages: user.children_ages || "",
                occupation: user.occupation || "",
                hobbies: user.hobbies || "",
                personality: user.personality || "",
                person_to_marry: user.person_to_marry || "",
                yourself_in_future: user.yourself_in_future || "",
            });
            setProfilePic(user.profile_pic ? `${process.env.REACT_APP_API_URL}${user.profile_pic}` : null);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching user data:", error);
            if (error.response?.status === 401) {
                navigate("/login");
            }
            setErrorMessage("Failed to load user data");
            setTimeout(() => setErrorMessage(""), 5000);
        }
    };

    // Update user details
    const updateSelectedUserDataByObj = (e) => {
        const { name, value } = e.target;
        setUserDetails({
            ...userDetails,
            [name]: value,
        });
    };

    // Handle file selection for profile picture
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            setProfilePic(URL.createObjectURL(file)); // Preview the selected image
        }
    };

    // Upload profile picture
    const uploadProfilePicture = async () => {
        if (!selectedFile) {
            setErrorMessage("Please select a photo to upload");
            setTimeout(() => setErrorMessage(""), 5000);
            return;
        }

        const TOKEN = localStorage.getItem("adminToken");
        const formData = new FormData();
        formData.append("profile_pic", selectedFile);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/users/update-profile-pic/${userid}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${TOKEN}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            setProfilePic(`${process.env.REACT_APP_API_URL}${response.data.data.profile_pic}`);
            setSelectedFile(null);
            toast.success("Profile picture updated successfully");
            setSuccessMessage("Profile picture updated successfully");
            setTimeout(() => setSuccessMessage(""), 5000);
        } catch (error) {
            console.error("Error uploading profile picture:", error);
            setErrorMessage("Failed to upload profile picture");
            setTimeout(() => setErrorMessage(""), 5000);
        }
    };

    // Delete profile picture
    const deleteProfilePicture = async () => {
        const TOKEN = localStorage.getItem("adminToken");
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/users/delete-profile-pic/${userid}`, {
                headers: {
                    Authorization: `Bearer ${TOKEN}`,
                },
            });
            setProfilePic(null);
            setSelectedFile(null);
            toast.success("Profile picture deleted successfully");
            setSuccessMessage("Profile picture deleted successfully");
            setTimeout(() => setSuccessMessage(""), 5000);
        } catch (error) {
            console.error("Error deleting profile picture:", error);
            setErrorMessage("Failed to delete profile picture");
            setTimeout(() => setErrorMessage(""), 5000);
        }
    };

    // Update user profile
    const updateSelectedUserData = async () => {
        // Validations
        if (userDetails.gender === "female") {
            if (
                !userDetails.fname ||
                !userDetails.lname ||
                !userDetails.dob ||
                !userDetails.gender ||
                !userDetails.address ||
                !userDetails.weight ||
                !userDetails.height ||
                !userDetails.eyecolor ||
                !userDetails.haircolor ||
                !userDetails.children_ages ||
                !userDetails.occupation ||
                !userDetails.hobbies ||
                !userDetails.personality ||
                !userDetails.person_to_marry ||
                !userDetails.yourself_in_future
            ) {
                setErrorMessage("Please fill in all required fields marked with *.");
                setTimeout(() => setErrorMessage(""), 5000);
                return;
            }
        } else {
            if (!userDetails.fname || !userDetails.lname || !userDetails.dob || !userDetails.gender || !userDetails.address) {
                setErrorMessage("Please fill in all required fields marked with *.");
                setTimeout(() => setErrorMessage(""), 5000);
                return;
            }
        }

        const TOKEN = localStorage.getItem("adminToken");
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/users/update/${userid}`,
                userDetails,
                {
                    headers: {
                        Authorization: `Bearer ${TOKEN}`,
                    },
                }
            );
            if (response.data.msg?.errors) {
                response.data.msg.errors.forEach((error) => {
                    setErrorMessage(error.message);
                    setTimeout(() => setErrorMessage(""), 5000);
                });
            } else {
                toast.success("Profile updated successfully");
                setSuccessMessage("Profile updated successfully");
                setTimeout(() => setSuccessMessage(""), 5000);
            }
        } catch (error) {
            console.error("Error updating user data:", error);
            setErrorMessage("Failed to update profile");
            setTimeout(() => setErrorMessage(""), 5000);
        }
    };

    useEffect(() => {
        fetchSingleUserData();
    }, []);

    return (
        <>
            <section className="page-info-sec">
                <div className="bg-fixed" style={{ backgroundImage: "url('./img/inner_banner.png')" }}></div>
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col">
                            <div className="page-info-block">
                                <h1>Update Profile</h1>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                                <p className="page_nav">
                                    <a href="/">Home</a>
                                    <span className="mx-2">/</span>
                                    <a href="#" className="currentPage">Update Profile</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="video-chat-form-sec secpd70">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            {successMessage && (
                                <div className="alert alert-success mt-3 text-center" role="alert">
                                    {successMessage}
                                </div>
                            )}
                            {errorMessage && (
                                <div className="alert alert-danger mt-3 text-center" role="alert">
                                    {errorMessage}
                                </div>
                            )}
                            <div className="main-from-wrap">
                                <div className="main-from-inner-wrap">
                                    <div className="title-centered text-center">
                                        <h2 className="title-30 mb-3">Update Profile</h2>
                                        <p></p>
                                    </div>
                                    <div className="formwrapper">
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="mb-3 mb-md-4">
                                                        <div className="profile-pic-container">
                                                            {profilePic ? (
                                                                <img
                                                                    src={profilePic}
                                                                    alt="Profile"
                                                                    className="profile-pic"
                                                                    style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius: "50%" }}
                                                                />
                                                            ) : (
                                                                <div
                                                                    className="profile-pic-placeholder"
                                                                    style={{
                                                                        width: "150px",
                                                                        height: "150px",
                                                                        backgroundColor: "#ccc",
                                                                        borderRadius: "50%",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        color: "#fff",
                                                                        fontSize: "16px",
                                                                    }}
                                                                >
                                                                    No Photo
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="mb-3 mb-md-4">
                                                        <label>
                                                            First Name:<span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="fname"
                                                            name="fname"
                                                            value={userDetails.fname}
                                                            className="form-control"
                                                            placeholder="Enter first name"
                                                            onChange={updateSelectedUserDataByObj}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="mb-3 mb-md-4">
                                                        <label>
                                                            Last Name:<span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            id="lname"
                                                            name="lname"
                                                            className="form-control"
                                                            placeholder="Enter last name"
                                                            value={userDetails.lname}
                                                            onChange={updateSelectedUserDataByObj}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="mb-3 mb-md-4">
                                                        <label className="form-label">
                                                            Date of Birth<span className="required">*</span>
                                                        </label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="dob"
                                                            value={userDetails.dob}
                                                            onChange={updateSelectedUserDataByObj}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="mb-3 mb-md-4">
                                                        <label className="form-label">
                                                            Gender<span className="required">*</span>
                                                        </label>
                                                        <select
                                                            className="form-control"
                                                            name="gender"
                                                            value={userDetails.gender}
                                                            onChange={updateSelectedUserDataByObj}
                                                        >
                                                            <option value="">Select Gender</option>
                                                            <option value="male">Male</option>
                                                            <option value="female">Female</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                {userDetails.gender === "female" && (
                                                    <>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    Weight<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter weight"
                                                                    className="form-control"
                                                                    value={userDetails.weight}
                                                                    name="weight"
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    Height<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter Height in cm"
                                                                    className="form-control"
                                                                    value={userDetails.height}
                                                                    name="height"
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    Eye Color<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter Eye Color"
                                                                    className="form-control"
                                                                    value={userDetails.eyecolor}
                                                                    name="eyecolor"
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    Hair Color<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter Hair Color"
                                                                    className="form-control"
                                                                    value={userDetails.haircolor}
                                                                    name="haircolor"
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    Do you have children? If so, what are their ages?<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter Children Ages"
                                                                    className="form-control"
                                                                    value={userDetails.children_ages}
                                                                    name="children_ages"
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    What is your Occupation or profession?<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter Occupation/profession"
                                                                    value={userDetails.occupation}
                                                                    className="form-control"
                                                                    name="occupation"
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    What are your favorite hobbies or activities?<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter hobbies or activities"
                                                                    value={userDetails.hobbies}
                                                                    className="form-control"
                                                                    name="hobbies"
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    How would you describe your personality or characteristics?<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Describe your personality"
                                                                    value={userDetails.personality}
                                                                    className="form-control"
                                                                    name="personality"
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    What type of man do you wish to date or marry?<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Describe man you wish to date or marry"
                                                                    className="form-control"
                                                                    name="person_to_marry"
                                                                    value={userDetails.person_to_marry}
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <div className="mb-3 mb-md-4">
                                                                <label className="form-label">
                                                                    Where do you see yourself in the future with the right man?<span className="required">*</span>
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="See yourself in the future with the right man"
                                                                    className="form-control"
                                                                    name="yourself_in_future"
                                                                    value={userDetails.yourself_in_future}
                                                                    onChange={updateSelectedUserDataByObj}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                <div className="col-lg-12">
                                                    <div className="mb-3 mb-md-4">
                                                        <label className="form-label">
                                                            Address<span className="required">*</span>
                                                        </label>
                                                        <textarea
                                                            name="address"
                                                            value={userDetails.address}
                                                            id="address"
                                                            className="form-control"
                                                            onChange={updateSelectedUserDataByObj}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                                <div className="col-md-1"></div>
                                                <div className="col-md-10">
                                                    <button type="button" className="btn-1 w-100" onClick={updateSelectedUserData}>
                                                        Update Profile
                                                    </button>
                                                </div>
                                                <div className="col-md-1"></div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default UpdateProfile;